import { useState } from 'react';
import { X as CloseIcon } from 'lucide-react';
import { TranslationsKeys } from 'types/translation';
import { useTranslate } from 'hooks/useTranslate';
import { FullscreenContainer } from 'components/FullscreenContainer';
import { Radio } from 'components/ui/Radio';
import { Button } from 'components/ui/Button';
import styles from '../MySurveys.module.scss';

export enum FilterValues {
  UPCOMING,
  OPEN,
  TODAY,
  TOMORROW,
  WEEK,
  MONTH
}

interface IProps {
  filter: FilterValues;
  onFilterChange: (filterValues: FilterValues) => void;
  onClose: () => void;
}

export const PlannedVisitFilters = ({ filter, onFilterChange, onClose }: IProps) => {
  const [selectedFilter, setSelectedFilter] = useState(filter);
  const { t } = useTranslate();
  
  const values: [FilterValues, TranslationsKeys][] = [
    [FilterValues.UPCOMING, TranslationsKeys.mySurveysPage_search_filters_myUpcomingVisits],
    [FilterValues.OPEN, TranslationsKeys.mySurveysPage_search_filters_myOpenVisits],
    [FilterValues.TODAY, TranslationsKeys.mySurveysPage_search_filters_myVisitsToday],
    [FilterValues.TOMORROW, TranslationsKeys.mySurveysPage_search_filters_myVisitsTomorrow],
    [FilterValues.WEEK, TranslationsKeys.mySurveysPage_search_filters_myVisitsThisWeek],
    [FilterValues.MONTH, TranslationsKeys.mySurveysPage_search_filters_myVisitsThisMonth],
  ];
  
  return (
    <FullscreenContainer>
      <div className={styles.mySurveysFilters}>
        <div className={styles.mySurveysFiltersHeading}>
          <span>{t(TranslationsKeys.common_filters)}</span>
          <button onClick={onClose} className={styles.mySurveysFiltersClose}>
            <CloseIcon />
          </button>
        </div>
        <div className={styles.mySurveysFiltersContainer}>
          <div className={styles.mySurveysFiltersContainerHeading}>
            {t(TranslationsKeys.mySurveysPage_myVisits_title)}
          </div>
          <div className={styles.mySurveysFiltersContainerItems}>
            {values.map(([key, text]) => (
              <div key={key} className={styles.mySurveysFiltersContainerItemsItem}>
                <Radio label={t(text)} isChecked={selectedFilter === key} onSelect={() => setSelectedFilter(key)} />
              </div>
            ))}
          </div>
        </div>
        <div className={styles.mySurveysFiltersActions}>
          <Button variant="secondary" onClick={onClose}>
            {t(TranslationsKeys.common_cancel)}
          </Button>
          <Button
            variant="primary"
            onClick={() => onFilterChange(selectedFilter)}>
            {t(TranslationsKeys.mySurveysPage_showVisits)}
          </Button>
        </div>
      </div>
    </FullscreenContainer>
  );
};
